/* =========================================================================
   Paieška pagal gaminio kodą (SKU)
   -------------------------------------------------------------------------
   Shopify greitoji paieška (predictive search) gaminio kodo neindeksuoja
   patikimai:
     • „006"  grąžindavo TIK 006r, o 006b (Apvali pintinė) likdavo nematoma;
     • „005"  grąžindavo TIK 005b, o 005r likdavo nematoma;
     • „013b" grąžindavo 10 nesusijusių padėklų (semantinis spėjimas).
   Pilna paieška (/search?q=) tuos pačius kodus randa tiksliai ir pilnai
   (patikrinta: visi 120 gaminių randami pagal savo kodą).

   Todėl: kai užklausa ATRODO KAIP KODAS (006, 006b, 005b-1, 027b-2a),
   sąrašą VISADA imam iš /search?...&view=nwjson ir juo PAKEIČIAM Shopify
   rezultatus. Anksčiau tai vykdavo tik tada, kai Shopify negrąžindavo nieko —
   dėl to ir atsirado klaida.

   Tema kviečia DU skirtingus adresus:
     1) /search/suggest.json           -> JSON
     2) /search/suggest?section_id=... -> HTML sekcija (ją naudoja langas)
   Apdorojam abu.
   ========================================================================= */
(function () {
  if (!window.fetch || window.__nwSearchFix) return;
  window.__nwSearchFix = true;

  var HAS_DIGIT = /\d/;
  /* 006 · 006b · 005b-1 · 027b-2a · 34 — t. y. gaminio kodas ar jo pradžia */
  var IS_CODE = /^\d{2,4}[a-z]?(?:-\d*[a-z]?)?$/i;
  var native = window.fetch.bind(window);

  function isCode(q) {
    return IS_CODE.test(String(q || '').trim());
  }
  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }
  function qOf(u) {
    try { return new URL(u, location.origin).searchParams.get('q') || ''; }
    catch (e) { return ''; }
  }
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    if (v == null || v === '') return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var n = parseFloat(String(v).replace(',', '.'));
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'lt',
        { style: 'currency', currency: cur }).format(n);
    } catch (e) { return v; }
  }
  function isLT() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('lt') === 0;
  }
  function label() { return isLT() ? 'Gaminiai' : 'Products'; }

  function nwjson(q) {
    return native(root() + '/search?q=' + encodeURIComponent(q) + '&type=product&view=nwjson')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Temos klasėmis paremtas gaminių sąrašas */
  function listHtml(list, q) {
    var out = '<div id="predictive-search-products" class="predictive-search-results__products"' +
      ' data-nw-code="' + esc(q || '') + '">' +
      '<h4 class="predictive-search-results__title">' + label() + '</h4>' +
      '<ul class="predictive-search-results__list predictive-search-results__wrapper-products list-unstyled"' +
      ' role="listbox" aria-label="' + label() + '">';
    list.slice(0, 8).forEach(function (p) {
      out += '<li class="predictive-search-results__card predictive-search-results__card--product" ref="resultsItems[]">' +
        '<div class="resource-card" data-resource-type="product">' +
        '<a class="resource-card__link" href="' + esc(p.url) + '">' +
        '<span class="visually-hidden">' + esc(p.title) + '</span></a>' +
        '<div class="resource-card__media" style="--resource-card-aspect-ratio: 1 / 1;">' +
        (p.image ? '<img class="resource-card__image" src="' + esc(p.image) +
          '" alt="" width="160" height="160" loading="lazy">' : '') +
        '</div><div class="resource-card__content">' +
        '<p class="resource-card__title paragraph">' + esc(p.title) + '</p>' +
        '<div><span class="price">' + esc(money(p.price)) + '</span></div>' +
        '</div></div></li>';
    });
    return out + '</ul></div>';
  }
  window.__nwListHtml = listHtml;

  /* Įdedam savo sąrašą į temos sekcijos HTML.
     Svarbu: jei Shopify jau parodė gaminių, juos PAKEIČIAM (o ne pridedam). */
  function injectBlock(html, block, count) {
    var out = html;
    var replaced = false;

    if (typeof DOMParser !== 'undefined' && html.indexOf('id="predictive-search-products"') !== -1) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var old = doc.querySelector('#predictive-search-products');
        if (old) {
          var tmp = doc.createElement('div');
          tmp.innerHTML = block;
          if (tmp.firstChild) {
            old.parentNode.replaceChild(tmp.firstChild, old);
            /* „vienas rezultatas" nuoroda nebegalioja, kai rodom kelis */
            if (count > 1) {
              var single = doc.querySelector('[data-single-result-url]');
              if (single && single.parentNode) single.parentNode.removeChild(single);
            }
            out = doc.body.innerHTML;
            replaced = true;
          }
        }
      } catch (e) { /* krentam į žemiau esančius variantus */ }
    }

    if (!replaced && html.indexOf('predictive-search-results__no-results') !== -1) {
      out = html.replace(
        /<p class="predictive-search-results__no-results">[\s\S]*?<\/p>/,
        block
      );
      replaced = out !== html;
    }

    if (!replaced && html.indexOf('data-search-results') !== -1) {
      out = html.replace(
        /(<div[^>]*class="predictive-search-results__inner"[^>]*>)/,
        '$1' + block
      );
      replaced = out !== html;
    }

    if (!replaced) return html;

    /* atnaujinam ir ekrano skaitytuvo pranešimą */
    return out.replace(
      /(role="status"[\s\S]{0,60}?aria-live="polite"\s*>)[\s\S]*?(<\/div>)/,
      '$1' + (isLT() ? 'Rasta rezultatų: ' : 'Results found: ') + count + '$2'
    );
  }

  window.fetch = function (input, init) {
    var u = urlOf(input);
    if (u.indexOf('/search/suggest') === -1) return native(input, init);
    var q = qOf(u);
    if (!q || !HAS_DIGIT.test(q)) return native(input, init);

    var code = isCode(q);
    var isJson = u.indexOf('/search/suggest.json') !== -1;

    return native(input, init).then(function (res) {
      if (!res.ok) return res;

      /* --- 1. JSON variantas --- */
      if (isJson) {
        return res.clone().json().then(function (data) {
          var r = data && data.resources && data.resources.results;
          var has = !!(r && r.products && r.products.length);
          /* kodą tikrinam visada; kitas užklausas — tik jei nieko nerasta */
          if (has && !code) return res;
          return nwjson(q).then(function (list) {
            if (!list || !list.length) return res;
            if (!data.resources) data.resources = { results: {} };
            if (!data.resources.results) data.resources.results = {};
            data.resources.results.products = list.map(function (p) {
              return {
                title: p.title, url: p.url, image: p.image, price: p.price,
                handle: '', body: '', vendor: '',
                variants: p.sku ? [{ sku: p.sku, title: p.sku, url: p.url,
                                     image: p.image, price: p.price }] : []
              };
            });
            return new Response(JSON.stringify(data), {
              status: 200, headers: { 'Content-Type': 'application/json' }
            });
          });
        }).catch(function () { return res; });
      }

      /* --- 2. HTML sekcijos variantas (jį naudoja paieškos langas) --- */
      return res.clone().text().then(function (html) {
        var has = html.indexOf('predictive-search-results__card--product') !== -1;
        if (has && !code) return res;
        return nwjson(q).then(function (list) {
          if (!list || !list.length) return res;
          var out = injectBlock(html, listHtml(list, q), list.length);
          if (out === html) return res;
          return new Response(out, {
            status: 200,
            headers: { 'Content-Type': res.headers.get('Content-Type') || 'text/html' }
          });
        });
      }).catch(function () { return res; });
    });
  };
})();


/* --- Atsarginis kelias: jei tema kada nors nustotų naudoti fetch ----------
   Stebim rezultatų langą: jei užklausa panaši į kodą (arba rodoma „nerasta"),
   patys užpildom sąrašą iš pilnos paieškos.                                */
(function () {
  var HAS_DIGIT = /\d/;
  var IS_CODE = /^\d{2,4}[a-z]?(?:-\d*[a-z]?)?$/i;
  var busy = false;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }

  function fix() {
    if (busy) return;
    var comps = document.querySelectorAll('predictive-search-component');
    for (var i = 0; i < comps.length; i++) {
      var comp = comps[i];
      var input = comp.querySelector('input[type="search"]');
      var box = comp.querySelector('.predictive-search-form__content') || comp;
      if (!input) continue;
      var q = (input.value || '').trim();
      if (!q || !HAS_DIGIT.test(q)) continue;

      var code = IS_CODE.test(q);
      var noRes = box.querySelector('.predictive-search-results__no-results');
      var products = box.querySelector('#predictive-search-products');

      /* jau mūsų sąrašas su ta pačia užklausa — nieko nedarom */
      if (products && products.getAttribute('data-nw-code') === q) continue;
      /* gaminiai rodomi, o užklausa ne kodas — paliekam temai */
      if (!noRes && !code) continue;
      if (!noRes && !products) continue;
      if (box.dataset.nwFilled === q) continue;

      (function (comp, box, q, target) {
        busy = true;
        fetch(root() + '/search?q=' + encodeURIComponent(q) + '&type=product&view=nwjson')
          .then(function (r) { return r.json(); })
          .then(function (list) {
            busy = false;
            if (!Array.isArray(list) || !list.length) return;
            var inp = comp.querySelector('input[type="search"]');
            if (!inp || (inp.value || '').trim() !== q) return;
            if (!target || !target.parentNode) return;
            var wrap = document.createElement('div');
            wrap.innerHTML = window.__nwListHtml ? window.__nwListHtml(list, q) : '';
            if (!wrap.firstChild) return;
            target.parentNode.replaceChild(wrap.firstChild, target);
            if (list.length > 1) {
              var single = box.querySelector('[data-single-result-url]');
              if (single && single.parentNode) single.parentNode.removeChild(single);
            }
            box.dataset.nwFilled = q;
          })
          .catch(function () { busy = false; });
      })(comp, box, q, noRes || products);
      return;
    }
  }

  function boot() {
    if (window.__nwPsBooted) return;
    window.__nwPsBooted = true;
    new MutationObserver(function () { setTimeout(fix, 60); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
